import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { updateAssetSubType } from '@api/assetTypes';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { IResponseError } from '@interfaces/errors/apiErrors';
import { IAssetSubTypeUpdateDTO } from '@interfaces/platform/dto/manageAssetTypesDTO';

import { ESnackbarTypes } from '@enums/common';
import { EErrorCodes } from '@enums/errorCodes';

import { MANAGE_ASSET_TYPES, UPDATE_ASSET_SUBTYPE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateUpdateAssetSubType = () => {
	const dispatch = useAppDispatch();

	const queryClient = useQueryClient();

	const {
		mutate: handleUpdateAssetSubType,
		isLoading: isLoadingUpdateAssetSubType,
	} = useMutation<IAssetSubTypeUpdateDTO>({
		mutationKey: [UPDATE_ASSET_SUBTYPE],
		mutationFn: updateAssetSubType,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.assetSubTypeUpdated,
				type: ESnackbarTypes.success,
			}));

			return [queryClient.invalidateQueries([MANAGE_ASSET_TYPES])];
		},
		onError: (err: IResponseError) => {
			if (!err.errors.find((item) => item.code === EErrorCodes.assetSubTypeNameMustBeUnique)) {
				handleErrorFromMessage(err);
			}
		},
	});

	return {
		handleUpdateAssetSubType,
		isLoadingUpdateAssetSubType,
	};
};
